import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../../../constant";
import { NavLink, useSearchParams } from "react-router-dom";
import i18next from "i18next";

const HOT_TYPE = ["Popular", "exclusiveBrandGames", "New"];

const MachineHotType = () => {
  const [searchParams] = useSearchParams();

  const searchParamsType = searchParams.get("type") || "Popular";

  return (
    <Flex gap="100px">
      {HOT_TYPE.map((type, index) => (
        <Box
          as={NavLink}
          key={`${type}-${index}`}
          w="220px"
          bgImage={`${COMMON_WEB_PATH}/now888/gameType${
            i18next.language == "tw" ? "" : `/${i18next.language}`
          }/${type}${searchParamsType === type ? "_active" : ""}.png`}
          bgSize="100% 100%"
          bgPos="center"
          bgRepeat="no-repeat"
          _hover={{
            bgImage: `${COMMON_WEB_PATH}/now888/gameType${
              i18next.language == "tw" ? "" : `/${i18next.language}`
            }/${type}_active.png`,
            bgSize: "100% 100%",
          }}
          onError={(e) => {
            e.target.src = `${COMMON_WEB_PATH}/now888/gameType/${type}${
              searchParamsType === type ? "_active" : ""
            }.png`;
            e.target.onerror = null; // Prevent infinite loop
          }}
          to={{
            search: `?type=${type}`,
          }}
        ></Box>
      ))}
    </Flex>
  );
};

export default MachineHotType;
